// Étapes qui terminent une affaire (spec § 11) : réglées dans les paramètres, lues par la carte, le tableau de bord
// et les alertes (fonction `deal_closed_stages` de la base). Une affaire à l'une de ces étapes n'est plus « en cours ».

export const DEFAULT_CLOSED_STAGES = ["ordered", "lost"];

export const isOpenStage = (stage: string, closedStages: string[]) =>
  !closedStages.includes(stage);

// À l'enregistrement : ne garde que les étapes qui existent encore, dans leur ordre.
export const keepExistingStages = (
  closedStages: string[] | undefined,
  stages: { value?: string }[] | undefined,
) =>
  (stages ?? [])
    .map((stage) => stage.value)
    .filter(
      (value): value is string => !!value && !!closedStages?.includes(value),
    );
